import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription, map } from 'rxjs';
import { AuthService, CountryNamePipe, DialogService, UserService } from '@wm-libs/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { User } from '@wm-libs/core';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, ReactiveFormsModule, MatInputModule, TranslateModule, CountryNamePipe],
})
export class ProfileInfoComponent implements OnDestroy {
  isEditMode = false;
  profileForm!: FormGroup;

  private userSubscription: Subscription;
  userData$!: User | null;

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((result) => result.matches));

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches));

  isMedium$ = this.breakpointObserver.observe([Breakpoints.Medium]).pipe(map((result) => result.matches));

  constructor(private breakpointObserver: BreakpointObserver, private fb: FormBuilder, private userService: UserService, private dialogService: DialogService, private authService: AuthService) {
    this.userSubscription = this.userService.userData$.subscribe((user) => {
      this.userData$ = user;
    });

    this.profileForm = this.fb.group({
      firstName: [''],
      lastName: [''],
      name: [''],
    });
  }

  changeUsername() {
    const config = {
      title: 'WM_TECH.PROFILE.CHANGE_USERNAME',
      app: 'tech',
      fields: [
        { name: 'firstName', label: 'WM_TECH.PROFILE.FIRSTNAME', type: 'input', value: this.userData$?.firstName || '', validators: [Validators.required] },
        { name: 'lastName', label: 'WM_TECH.PROFILE.LASTNAME', type: 'input', value: this.userData$?.lastName || '', validators: [Validators.required] },
      ],
    };

    const dialogRef = this.dialogService.openPopup(config);

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.firstName && result?.lastName) {
        this.authService.updateUserInfo(result?.firstName, result?.lastName, '').subscribe((res) => {
          this.userService.setUserData(res);
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}
